import { CommonModule, DecimalPipe } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, Optional, SkipSelf, LOCALE_ID, APP_INITIALIZER } from '@angular/core';

import { AuthRequestGuard } from '../auth/auth-request-guard.service';

import { ApiMsService } from './services/api-ms.service';
import { appConfigFactory } from './services/app-config.factory';
import { AppConfigGuard } from './services/app-config.guard';
import { AppConfigService } from './services/app-config.service';
import { DateService } from './services/date.service';
import { DocumentsService } from './services/documents.service';
import { GlobalInterceptor } from './services/global.interceptor';
import { GlobalService } from './services/global.service';
import { GoogleAnalyticsEventsService } from './services/google-analytics-events.service';
import { InvoiceService } from './services/invoice.service';
import { LoadingService } from './services/loading.service';
import { NotificationService } from './services/notification.service';
import { PermissionService } from './services/permission.service';
import { ProfileService } from './services/profile.service';
import { PwdService } from './services/pwd.service';
import { RequestCpeService } from './services/request-cpe.service';
import { RetailerService } from './services/retailer.service';
import { UserService } from './services/user.service';
import { WorkOrderSchedulingService } from './services/work-order-scheduling.service';
import { WorldCountriesService } from './services/world-countries.service';

import { AuthGuard } from 'app/auth/auth-guard.service';
import { AuthService } from 'app/auth/auth.service';
import { ContractService } from 'app/contract-manager/_services/contract.service';
import { EnergyService } from 'app/energy/energy.service';
import { RequestPermissionService } from 'app/request/request-permission.service';
import { RequestNavigationService } from 'app/request/request.navigation.service';
import { RequestService } from 'app/request/request.service';
import { ScheduleService } from 'app/schedule/schedule.service';
import { UserCreateEditService } from 'app/user/user-create-edit/user-create-edit.service';

@NgModule({
  imports: [CommonModule],
})
export class CoreModule {
  static forRoot() {
    return {
      ngModule: CoreModule,
      providers: [
        GlobalService,
        LoadingService,
        { provide: APP_INITIALIZER, useFactory: appConfigFactory, deps: [AppConfigService], multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: GlobalInterceptor, deps: [LoadingService], multi: true },
        { provide: LOCALE_ID, useValue: 'pt-PT' },
        NotificationService,
        AuthService,
        AuthGuard,
        AuthRequestGuard,
        UserService,
        ProfileService,
        PermissionService,
        PwdService,
        ScheduleService,
        RequestService,
        ContractService,
        EnergyService,
        UserCreateEditService,
        RetailerService,
        DecimalPipe,
        DateService,
        GoogleAnalyticsEventsService,
        RequestPermissionService,
        ApiMsService,
        DocumentsService,
        InvoiceService,
        RequestCpeService,
        AppConfigGuard,
        RequestNavigationService,
        WorldCountriesService,
        WorkOrderSchedulingService,
      ],
    };
  }

  constructor(@Optional() @SkipSelf() core: CoreModule) {
    if (core) {
      throw new Error('CoreModule is already loaded. Import it in the AppModule only!');
    }
  }
}
